import { toFormValidator } from '@vee-validate/zod'
import * as zod from 'zod'

export const validationSchema = toFormValidator(zod.object({
    amount: zod.string().regex(/^(?:[1-9]\d{0,2}|1\d{3}|2000)$/, { message: 'Postcards should be  between 1 to 2000.' })
}))
